import { Button } from '@/components/Elements';
import { useDialog } from '@/hooks/useDialog';
import { BookmarkSquareIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { SaveFilterModal } from './SaveFilterModal';

interface SaveFilterButtonProps {
  className?: string;
}

export const SaveFilterButton = ({ className }: SaveFilterButtonProps) => {
  const { t } = useTranslation();
  const { isOpen, openDialog, closeDialog } = useDialog();

  return (
    <>
      <Button
        color="secondary"
        size="xs"
        onClick={openDialog}
        className={className}
        startIcon={<BookmarkSquareIcon className="size-3" />}
      >
        {t('保存')}
      </Button>

      <SaveFilterModal isOpen={isOpen} onClose={closeDialog} />
    </>
  );
};
